export enum ErrorCode {
    NeedCAPTCHA = 'NeedCAPTCHA',
    NeedToUseAadLogin = 'NeedToUseAadLogin',
    InvalidPhoneNumber = 'InvalidPhoneNumber',
    OnlyOneMarketingCampaignAllowed = 'OnlyOneMarketingCampaignAllowed',
    InvalidCredentialNeedCaptcha = 'InvalidCredentialNeedCaptcha',
}
